import React, { useEffect, useMemo, useState, useCallback, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import {
    setTheInternalDepartmentRetreve_TicketViewsActions, // ticket details
    setthecommentRetieveDatasActions,  // comment records
    settheinternaldepartmentcommanddatagetaction,
    setTheTrackingrecordgetList_remarksRetrieveActions, /// remarks records
    setTheInternalDepartmentRetreve_TicketRemarksCRUDActions,
    // settehTicketStatusChanges,
    setTheInternalDepartmentRetreve_TicketTicketChangesActions,
    SetActiveTabs,
    settheticketTimelineretieveDatasActions,
    setTheInternalDepartmentRetreve_TicketFeedbackActions,
    settheRemarkspostActions,
    setTheInternalDepartmentRetreve_TicketRemarksActions,
    setTheInternalDepartmentRetreve_TicketTImelinesActions,
    settheinternaldepartmentRemarksgetaction,
    setthereassignandAssignRejectDataActions,
    settheAssignAndReassigns,
    settheTicketStatusNames,
    settheTicketReassignIds,
    settheTicketescalationActions,
    settheTicketTicketJourneyActions
} from "../../../../Redux/Slice"
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { PresentUrl } from "../../../../text/apidata";
import { store } from "../../../../Redux/Store";
import axios from "axios";
import downloadimg from "../../../../Assets/AppComponent/Union (11).svg"
import sendimg from "../../../../Assets/AppComponent/Union (13).svg"
import Uploadimg from "../../../../Assets/AppComponent/Union (12).svg"
import galleyimg from "../../../../Assets/AppComponent/Vector (20).svg"
import Select from "react-select";
import profile2 from "../../../../Assets/AppComponent/Profile/profile2.png";

import PDFIMAGE from "../../../../Assets/AppComponent/Rectangle.png"
import excelimg from "../../../../Assets/AppComponent/download.png"
import gallimages from "../../../../Assets/AppComponent/Vector (20).svg"

import phoneimg from "../../../../Assets/AppComponent/Union (16).svg"

import ArrowImgs from "../../../../Assets/AppComponent/Group 8.svg"
import downloadimg2 from "../../../../Assets/AppComponent/Group 427320153.svg"

import galleryimg2 from "../../../../Assets/AppComponent/image 1.svg"


import pdfimg2 from "../../../../Assets/AppComponent/pdf 1 (1).svg"


import Bad from "../../../../Assets/AppComponent/Vector (18).svg"
import acceptable from "../../../../Assets/AppComponent/Vector (19).svg"
import good from "../../../../Assets/AppComponent/Union (9).svg"
import excellent from "../../../../Assets/AppComponent/Union (6).svg"


import Badunactive from "../../../../Assets/AppComponent/Union (8).svg"
import acceptableun from "../../../../Assets/AppComponent/Union (7).svg"
import goodun from "../../../../Assets/AppComponent/Vector (16).svg"
import excellentun from "../../../../Assets/AppComponent/Union (10).svg"

import doublArrow from "../../../../Assets/AppComponent/Group 427320086.svg"
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from "@mui/material";
import { Card, CardContent, Typography } from "@mui/material";
import ticketactiveimgs from "../../../../Assets/AppComponent/Group.svg"
import { Tooltip } from "react-tooltip";
import dropdowns from "../../../../Assets/AppComponent/Group 427320178.svg"

import tciketimgs from "../../../../Assets/AppComponent/Vector.svg";
import moment from "moment";

import ticketJourneyimg1 from "../../../../Assets/AppComponent/Vector (42).svg"

import ticketJourneyimg2 from "../../../../Assets/AppComponent/Vector (43).svg"

import closeticketviews from "../../../../Assets/AppComponent/Vector (44).svg"



const InternalsView = () => {
    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive
    );
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const state = useSelector((state) => state)
    const initialState = {
        name: "",
        documents: [],
        uds_user_id: state.SideBarFiles.LoginIDs,
        ticket_id: state.StateManagementOverallCall.TicketExternalViewListedIds

    };
    const [remarks, setremarts] = useState(initialState);

    const initialState2 = {
        name: "",
        status: "",
        ticket_id: "",
        uds_user_id: ""
    };

    const [Commentpopup, setcommetpoup] = useState(false);
    const steps = ["Open", "In Progress", "Review", "Resolved"];
    var currentStep = 1;

    const [comment, setcomment] = useState(initialState2);
    const [TickeREtrievdatas, setTicketRetrievedata] = useState([]);
    const [Remarskspopuo, setremarkspopup] = useState(false)
    // const [remarksseparate, setremarksseparatepopup] = useState(false)

    const [uploadedFiles, setUploadedFiles] = useState([]);

    const [isDragging, setIsDragging] = useState(false);
    const [PresentUrls, setPresentUrls] = useState([]);
    const [presenturlInUrl, seturlandfile] = useState([])


    const [croppedFileState, setcroppedFilestatet] = useState([]);
    const [documentnotuploads, setdosumentuploads] = useState(false)
    const options = [
        { value: "1", label: "Inprocess" },
        { value: "2", label: "Review" },
    ];
    const [isModalOpen, setModalOpen] = useState(false);
    const chatContainerRef = useRef(null);

    // Function to auto-scroll to the bottom
    const scrollToBottom = () => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
    };

    const [users, setusers] = useState([])
    const [RejectionPopup, setRejectionPopups] = useState(false)
    const [ActiveofUploads, setActiveonUploads] = useState(1)

    useEffect(() => {
        if (TickeREtrievdatas) {
            const l1Users = TickeREtrievdatas.l1_users || [];
            const l2Users = TickeREtrievdatas.l2_users || [];
            const l3Users = TickeREtrievdatas.l3_users || [];
            const excludedIDs = state.SideBarFiles.LoginIDs || []; // IDs to exclude

            const allUsers = [
                ...l1Users.map((user, index) => ({
                    id: index + 1,
                    name: user.first_name,
                    login_id: user?.id,
                })),
                ...l2Users.map((user, index) => ({
                    id: l1Users.length + index + 1,
                    name: user.first_name,
                    login_id: user?.id,
                })),
                ...l3Users.map((user, index) => ({
                    id: l1Users.length + l2Users.length + index + 1,
                    name: user.first_name,
                    login_id: user?.id,
                })),
            ];

            // Filter out users whose login_id matches any ID in excludedIDs
            const filteredUsers = allUsers.filter(user => !excludedIDs.includes(user.login_id));

            setusers(filteredUsers);
        }
    }, [TickeREtrievdatas, state.SideBarFiles.LoginIDs]); // Include all relevant dependencies

    const [suggestions, setSuggestions] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(-1);



    const handleSelectSuggestion = (user) => {
        if (!user || !user.name) {
            console.error("Invalid user or user name");
            return;
        }

        const updatedValue = remarks?.name.replace(/@\w*$/, `@${user.name} `);
        setremarts({
            ...remarks,
            name: updatedValue,
        });

        setSuggestions([]);
        setActiveSuggestionIndex(-1);
    };


    useEffect(() => {
        if (suggestions.length > 0 && activeSuggestionIndex === -1) {
            setActiveSuggestionIndex(0); // Select the first suggestion by default
        }
    }, [suggestions]);


    // Scroll to bottom when messages change
    useEffect(() => {
        scrollToBottom();
    }, [state.internalTicketRemarks.InternalDepartments_TicketsretrieveRemark]);


    const timelineRef = useRef(null);

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (timelineRef.current) {
                timelineRef.current.scrollTop = timelineRef.current.scrollHeight;
                // console.log(timelineRef.current.scrollHeight, "asoduaosdiapsodupoasd ");

            }
        }, 100); // Adjust the delay as needed
        return () => clearTimeout(timeout); // Clean up timeout
    }, [
        state.internalcommandticketgetdata.internaldepartmentticketgetdata,
        state.internalTicketFeedBack.InternalDepartments_TicketsFeedback,
        state.internalTicketRemarks.InternalDepartments_TicketsretrieveRemark,
        state.FormsIDList.ActiveTabs
    ]);


    const timelineRefremarks = useRef(null);




    useEffect(() => {
        const timeout = setTimeout(() => {
            if (timelineRefremarks.current) {
                timelineRefremarks.current.scrollTop = timelineRefremarks.current.scrollHeight;
                // console.log(timelineRef.current.scrollHeight, "asoduaosdiapsodupoasd ");

            }
        }, 100); // Adjust the delay as needed
        return () => clearTimeout(timeout); // Clean up timeout
    }, [
        state.internalcommandticketgetdata.internaldepartmentticketgetdata,
        state.internalTicketFeedBack.InternalDepartments_TicketsFeedback,
        state.internalTicketRemarks.InternalDepartments_TicketsretrieveRemark,
        state.FormsIDList.ActiveTabs
    ]);


    const Remarkesref = useRef(null);

    const scrollToBottomrealremarks = () => {
        if (Remarkesref.current) {
            Remarkesref.current.scrollTop = Remarkesref.current.scrollHeight;
        }
    };

    // Scroll to bottom when messages change
    useEffect(() => {
        scrollToBottomrealremarks();
    }, [state.internalcommandticketgetdata.internaldepartmentticketgetdata, state.FormsIDList.ActiveTabs]);

    const [progress, setProgress] = React.useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 10));
        }, 800);

        return () => {
            clearInterval(timer);
        };
    }, []);




    const [TicketConfirmPopup, setTicketConfirmPopup] = useState(false)
    const [TicketTimeline, setTicketLIne] = useState([])
    const [Escalationpopup, setEscalationpoup] = useState(true);
    const [showTooltip, setShowTooltip] = useState(false);

    const [showTooltipone, setShowTooltipone] = useState(false);
    const [showTooltiptwo, setShowTooltiptwo] = useState(false);

    const [showToolphone, setShowToolPhone] = useState(false);

    const scrollRef = useRef(null);


    const [remainingTime, setremainingTime] = useState(1);
    const [activeFeedback, setactiveFeedback] = useState("Bad")
    const [ticketactivenames, setticketactivenames] = useState("")

    const feedbackOptions = [
        { id: "bad", label: "Bad", imgSrc: activeFeedback == "bad" ? Bad : Badunactive, backimg: Bad },
        { id: "acceptable", label: "Acceptable", imgSrc: activeFeedback == "acceptable" ? acceptable : acceptableun, backimg: acceptable },
        { id: "good", label: "Good", imgSrc: activeFeedback == "good" ? good : goodun, backimg: good },
        { id: "excellent", label: "Excellent", imgSrc: activeFeedback == "excellent" ? excellent : excellentun, backimg: excellent },
    ];


    const formatDate = (dateString) => {
        const dateObject = new Date(dateString);

        const day = String(dateObject.getDate()).padStart(2, '0');
        const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = dateObject.getFullYear();

        return `${day} / ${month} / ${year}`;
    };



    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = 100; // Vertical scroll
            scrollRef.current.scrollLeft = 50; // Horizontal scroll
        }
    }, []);

    const formatDateTime = (dateString) => {
        const dateObject = new Date(dateString);

        const day = String(dateObject.getDate()).padStart(2, '0');
        const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = dateObject.getFullYear();

        const hours = dateObject.getHours();
        const minutes = String(dateObject.getMinutes()).padStart(2, '0');

        // Convert hours to 12-hour format and determine AM/PM
        const amPm = hours >= 12 ? 'pm' : 'am';
        const formattedHours = hours % 12 || 12; // Converts 0 to 12 for midnight

        return `${day}/${month}/${year}, ${formattedHours}.${minutes} ${amPm}`;
    };
    useEffect(() => {
        if (state.internalTicketTimeline.InternalDepartments_TicketsretrieveTimeline) {
            setTicketLIne([state.internalTicketTimeline.InternalDepartments_TicketsretrieveTimeline])
        }
    }, [state.internalTicketTimeline.InternalDepartments_TicketsretrieveTimeline])

    // useEffect(()=>{
    //     if(ticketretrieve)
    // })

    const StepTickets = Object.entries(state.internalTicketTimeline.InternalDepartments_TicketsretrieveTimeline);

    var DurationOpions = [
        {
            value: "0",
            label: "Minutes"
        },
        {
            value: "1",
            label: "Hours"
        },
        {
            value: "2",
            label: "Day"
        },
    ]
    function extractTimeFromDate(dateString, options = { hour: "2-digit", minute: "2-digit", hour12: true }) {
        return new Date(dateString).toLocaleTimeString("en-US", options);
    }



    const downloadAll = (remarkdocuments) => {
        const allLinks = remarkdocuments;

        if (!allLinks || allLinks.length === 0) {
            alert("No documents available for download.");
            return;
        }

        allLinks.forEach((link, index) => {
            setTimeout(() => {
                window.open(link, "_blank");
            }, index * 500); // Opens a new window every 500ms (adjust as needed)
        });
    };



    const formatedDateList = (dateString) => {
        const date = new Date(dateString);

        const dateOptions = {
            month: "short", // e.g., Dec
            day: "2-digit", // e.g., 22
            year: "numeric", // e.g., 2024
        };

        // Options for time formatting (only time)
        const timeOptions = {
            hour: "2-digit", // e.g., 02
            minute: "2-digit", // e.g., 16
            hour12: true, // e.g., AM/PM format
        };

        // Format the date and time separately
        const formattedDate = date.toLocaleDateString("en-US", dateOptions);
        const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

        // Combine the formatted date and time
        return `${formattedDate}, ${formattedTime}`;
    };

    const formatedDateListwithouttime = (dateString) => {
        const date = new Date(dateString);

        // Options for date formatting (only date)
        const dateOptions = {
            month: "short", // e.g., Dec
            day: "2-digit", // e.g., 22
            year: "numeric", // e.g., 2024
        };

        // Options for time formatting (only time)
        const timeOptions = {
            hour: "2-digit", // e.g., 02
            minute: "2-digit", // e.g., 16
            hour12: true, // e.g., AM/PM format
        };

        const formattedDate = date.toLocaleDateString("en-US", dateOptions);
        const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

        // Combine the formatted date and time
        return `${formattedDate}`;
    };




    const overdueFunctions = (ticketretrieve) => {
        const convertToMinutes = (days, hours, minutes) => (days * 24 * 60) + (hours * 60) + minutes;
        let differenceInMinutes


        function calculateTimeStatus(differenceInMinutes) {

            console.log(differenceInMinutes, "differenceInMinutes", differenceInMinutes * -1);

            if (differenceInMinutes > 0 || differenceInMinutes == 0) {
                return "Overdue";
            }

            if ((differenceInMinutes * -1) >= 1440) {
                // More than or equal to 1 day
                const days = Math.floor(differenceInMinutes * -1) / (60 * 24);
                return `${days} Days left`;
            }

            if ((differenceInMinutes * -1) >= 60) {
                // More than or equal to 1 hour
                const hours = Math.floor(differenceInMinutes * -1 / 60);
                return `${hours} Hours left`;
            }

            // Less than 1 hour
            const minutes = differenceInMinutes * -1;
            return `Minutes left 
            ${minutes}`;
        }
        var remainingTimevalues


        const formatTime = (ms) => {
            const days = Math.floor(ms / (1000 * 60 * 60 * 24));
            const hours = Math.floor((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
            return { days, hours, minutes };
        };

        const formatTimeLevel = (ms, Levelonbetypes) => {
            return {
                days: Levelonbetypes === "2" ? ms : 0,
                hours: Levelonbetypes === "1" ? ms : 0,
                minutes: Levelonbetypes === "0" ? ms : 0,
            };
        };

        if (ticketretrieve?.created_at && ticketretrieve?.department_users?.l1_user_TAT) {
            const createdDate = new Date(ticketretrieve.created_at);
            const currentDate = new Date();
            const differenceInMs = currentDate - createdDate;

            const timeDifference = formatTime(differenceInMs);

            const LevelonbeTAT = Number(ticketretrieve.department_users.l1_user_TAT);
            const Levelonbetypes = ticketretrieve.department_users.l1_time_type;

            const period1Minutes = convertToMinutes(
                timeDifference.days,
                timeDifference.hours,
                timeDifference.minutes
            );

            const period2Minutes = convertToMinutes(
                Levelonbetypes === "2" ? LevelonbeTAT : 0,
                Levelonbetypes === "1" ? LevelonbeTAT : 0,
                Levelonbetypes === "0" ? LevelonbeTAT : 0
            );

            differenceInMinutes = period1Minutes - period2Minutes;
            remainingTimevalues = calculateTimeStatus(differenceInMinutes);
            return remainingTimevalues

        }

        return remainingTimevalues


    };

    const formatDatefeed = (dateString) => {
        const dateObject = new Date(dateString);

        const day = String(dateObject.getDate()).padStart(2, '0');
        const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = dateObject.getFullYear();

        return `${day}/${month}/${year}`;
    };

    const HandleChanges = (e) => {
        setremarts((pre) => {
            return {
                ...pre,
                [e.target.name]: e.target.value,
            };
        });
    };



    const HandleChangescomments = (e) => {
        const inputValue = e.target.value;
        setcomment((pre) => {
            return {
                ...pre,
                [e.target.name]: inputValue.charAt(0).toUpperCase() + inputValue.slice(1),
            };



        });


    };


    //// TICKET RETRIEV
    useEffect(() => {
        if (state.StateManagementOverallCall.TicketExternalViewListedIds) {
            const payload = {
                EditId: state.StateManagementOverallCall.TicketExternalViewListedIds

            }
            dispatch(setTheInternalDepartmentRetreve_TicketViewsActions(payload))
        }
    }, [state.StateManagementOverallCall.TicketExternalViewListedIds])

    /// REMARKS RETRIEVE

    useEffect(() => {
        if (state.StateManagementOverallCall.TicketExternalViewListedIds && state.FormsIDList.ActiveTabs == 1) {
            const payload = {
                ticket: state.StateManagementOverallCall.TicketExternalViewListedIds

            }
            dispatch(setTheInternalDepartmentRetreve_TicketRemarksActions(payload))
        }
    }, [state.StateManagementOverallCall.TicketExternalViewListedIds, state.FormsIDList.ActiveTabs])


    useEffect(() => {
        if (state.StateManagementOverallCall.TicketExternalViewListedIds) {
            const payload = {
                ticket_id: state.StateManagementOverallCall.TicketExternalViewListedIds

            }
            dispatch(setTheInternalDepartmentRetreve_TicketTImelinesActions(payload))
        }
    }, [state.StateManagementOverallCall.TicketExternalViewListedIds, state.ticketstatuschanges.ticketStatusChanges])


    console.log(state.StateManagementOverallCall.TicketExternalViewListedIds, "sadjaslkd TicketExternalViewListedIds");

    useEffect(() => {
        if (state.StateManagementOverallCall.TicketExternalViewListedIds !== ""
        ) {
            const payload = {
                ticket: state.StateManagementOverallCall.TicketExternalViewListedIds

            }
            dispatch(settheinternaldepartmentcommanddatagetaction(payload))
        }
    }, [state.StateManagementOverallCall.TicketExternalViewListedIds,])


    useEffect(() => {
        if (state.StateManagementOverallCall.TicketExternalViewListedIds) {
            const payload = {
                ticket: state.StateManagementOverallCall.TicketExternalViewListedIds

            }
            dispatch(setTheInternalDepartmentRetreve_TicketFeedbackActions(payload))
        }
    }, [state.StateManagementOverallCall.TicketExternalViewListedIds, state.FormsIDList.ActiveTabs == 2])





    useEffect(() => {
        if (state.internalTicketView.InternalDepartments_Ticketsretrievedatas) {
            setremarts({
                ...remarks,
                uds_user_id: state.internalTicketView.InternalDepartments_Ticketsretrievedatas?.ticket_data?.uds_user_id?.id
            })

            setcomment({
                ...comment,
                uds_user_id: state.internalTicketView.InternalDepartments_Ticketsretrievedatas?.uds_user_id?.id
            })

            setTicketRetrievedata(state.internalTicketView.InternalDepartments_Ticketsretrievedatas)

        }
    }, [state.internalTicketView.InternalDepartments_Ticketsretrievedatas])

    const capitalizeFirstLetter = (Letter) => {
        return Letter.charAt(0).toUpperCase() + Letter.slice(1);
    };


    useEffect(()=>{
        dispatch(SetActiveTabs(4));
    },[])









    useEffect(() => {
        if (uploadedFiles.length == 0) {
            setdosumentuploads(false)
        }
    }, [uploadedFiles])

    const removeFile = (index) => {
        setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
        setcroppedFilestatet((prev) => prev.filter((_, i) => i !== index));
        setPresentUrls((prev) => prev.filter((_, i) => i !== index));
        seturlandfile((prev) => prev.filter((_, i) => i !== index));
    };


    useEffect(() => {
        if (presenturlInUrl) {
            setremarts(prevState => ({
                ...prevState,
                documents: presenturlInUrl // Assign the new documents list
            }));
        }

    }, [presenturlInUrl])
    useEffect(() => {

        if (TickeREtrievdatas?.client_ticket_id != null) {
            const payload = {
                EditId: TickeREtrievdatas?.client_ticket_id,
                paramsdata: {
                    from_place: "external_ticket"
                }
            }
            dispatch(settheTicketescalationActions(payload))
        }

    }, [TickeREtrievdatas])



    useEffect(() => {
        if (TickeREtrievdatas?.id !== ""
            && TickeREtrievdatas?.id !== "" && TickeREtrievdatas?.id != undefined
        ) {

            const payload = {
                root_ticket: TickeREtrievdatas?.id,
                // ticket_id: state.StateManagementOverallCall.TicketIDS

            }
            dispatch(settheTicketTicketJourneyActions(payload))
        }
    }, [TickeREtrievdatas, state.FormsIDList.ActiveTabs == 4])


    console.log(TickeREtrievdatas, "asdyoiausdiouasd TickeREtrievdatas");


    const capitalizeEachWord = (str) => {
        return str && typeof str === 'string'
            ? str
                .split(' ') // Split the string into an array of words
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
                .join(' ') // Join the words back into a string
            : ''; // Return an empty string if the input is invalid
    };


    const truncateText = (text, maxLength) => {
        if (text.length <= maxLength) {
            return text;
        }
        return text.substring(0, maxLength) + "...";
    };

    // console.log(state.ticketexcalationrecordoflist?.ticketescalationdatas, "sadiopaisd ticketescalationdatas");
    const formatedDateListwithtime = (dateString) => {
        const date = new Date(dateString);

        // Options for date formatting (only date)
        const dateOptions = {
            month: "short", // e.g., Dec
            day: "2-digit", // e.g., 22
            year: "numeric", // e.g., 2024
        };

        const timeOptions = {
            hour: "2-digit", // e.g., 02
            minute: "2-digit", // e.g., 16
            hour12: true, // e.g., AM/PM format
        };

        // Format the date and time separately
        const formattedDate = date.toLocaleDateString("en-US", dateOptions);
        const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

        // Combine the formatted date and time
        return `${formattedDate}-${formattedTime}`;
    };



    return (
        <>
            <div className={`TicketingSytemview ${stateDisplay ? " POPUP" : "outerPOPUP"}`}>
                <div className="col BodyContent LeaveEdits TicketSystem">
                    <div className="card CardContent">
                        <div className="card-body cards ">
                            <div className="UserPoup">
                                <div className="BeforForms">
                                    <div className="Form">
                                        <div className="ModalHeader">
                                            <span>Ticket Details</span>
                                            <div
                                                className="CloseIcon"
                                                onClick={() => {
                                                    navigate("/ticketviews")
                                                }}
                                            >
                                                {/* <CloseOutlinedIcon /> */}

                                                <button className='CloseButtonsofTicketViews'>
                                                    <span className='BackOfTicketViewsButon'>
                                                    <img src={closeticketviews}/>
                                                    <span>Back</span>
                                                    </span>
                                                </button>


                                            </div>
                                        </div>
                                        <div className="Modal-Body Modal-bodyTracking">
                                            <div className='row InnerFormsDetails InnerFormsDetailsviews'>

                                                <div className="col-7">


                                                    <div className='TicketDetailsOverallCard'>
                                                        <div className="card CardBox ">
                                                            <div className='HeaderTimelines HeaderofClientList'>
                                                                <div className='HeaderHeadingClientname'>
                                                                    <div className='InnerClientCrendials'>
                                                                        <div className='clientimgs'>
                                                                            <img src={profile2} />
                                                                        </div>

                                                                        <div className='ClientLableForms'>
                                                                            <div className='CardofLabels'>

                                                                                <h6>{TickeREtrievdatas?.uds_user_id?.first_name ?
                                                                                    truncateText(capitalizeEachWord(TickeREtrievdatas?.uds_user_id?.first_name.toLowerCase()), 40)
                                                                                    : ""}

                                                                                </h6>

                                                                            </div>

                                                                            <div className='InnerTimelabel'

                                                                                style={{
                                                                                    backgroundColor:
                                                                                        TickeREtrievdatas?.priority === "2"
                                                                                            ? "red"
                                                                                            : TickeREtrievdatas?.priority === "1"
                                                                                                ? "hsla(15, 88%, 59%, 1)"
                                                                                                : TickeREtrievdatas?.priority === "0"
                                                                                                    ? "hsla(15, 88%, 59%, 1)"
                                                                                                    : "transparent",
                                                                                }}

                                                                            >
                                                                                {TickeREtrievdatas?.priority === "0"
                                                                                    ? "LOW PRIORITY"
                                                                                    : TickeREtrievdatas?.priority === "1"
                                                                                        ? "MEDIUM PRIORITY"
                                                                                        : TickeREtrievdatas?.priority === "2"
                                                                                            ? "HIGH PRIORITY"
                                                                                            : "---"}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className='ClientNames'>
                                                                        <div className='ClientUserNames'>
                                                                            <div className='ClientDeatilsRecords'>
                                                                                <div

                                                                                    onMouseEnter={() => setShowToolPhone(true)}
                                                                                    onMouseLeave={() => setShowToolPhone(false)}
                                                                                >
                                                                                    <img src={phoneimg} />
                                                                                </div>

                                                                                {showToolphone && (
                                                                                    <div className="custom-tooltip">
                                                                                        <span>{TickeREtrievdatas?.uds_user_id?.phone_number || 'No Phone Number Available'}</span>
                                                                                    </div>
                                                                                )}

                                                                                <span>{TickeREtrievdatas?.uds_user_id?.user_role?.role ? TickeREtrievdatas?.uds_user_id?.user_role?.role : "---"}</span>




                                                                            </div>


                                                                            <span className='Createddate Createddatetickets'>{" Created : "}
                                                                                <span className='DateFill' >
                                                                                    {TickeREtrievdatas?.created_at ? formatedDateListwithouttime(TickeREtrievdatas?.created_at) : ""}
                                                                                </span>
                                                                            </span>

                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>


                                                        </div>


                                                        <div className="col-5 Recentcard mb-3">
                                                            <div className="card  ProgressionsCards " >
                                                                <div className='HeaderTimelines'>
                                                                    <div className='HeaderHeading'>
                                                                        <h5>Progression</h5>
                                                                    </div>

                                                                </div>
                                                                <div className="progression-container">

                                                                    <div className="progression-body">
                                                                        <div className="status">
                                                                            <span className="status-label open"
                                                                                style={{
                                                                                    background: TickeREtrievdatas?.status == 0 ? "#FDEDE9" :
                                                                                        TickeREtrievdatas?.status == 1 ? "#FFF8E5" :
                                                                                            TickeREtrievdatas?.status == 2 ? "#E7F8ED" : // Completed - light green background
                                                                                                TickeREtrievdatas?.status == 3 ? "#DFFFE3" : // Close - light green background for Close
                                                                                                    TickeREtrievdatas?.status == 4 ? "#FFDDDD" :
                                                                                                        TickeREtrievdatas?.status == 5 ?
                                                                                                            "#FFDDDD" : TickeREtrievdatas?.status == 6 ?
                                                                                                                "#E7F8ED" : TickeREtrievdatas?.status == 7 && "#FDEDE9"
                                                                                    , // Default for Reopen - light red background
                                                                                    color: TickeREtrievdatas?.status == 0 ? "#ED4C28" : // Open - red text
                                                                                        TickeREtrievdatas?.status == 1 ? "#FFB800" : // In Progress - yellow text
                                                                                            TickeREtrievdatas?.status == 2 ? "#12B749" : // Completed - green text
                                                                                                TickeREtrievdatas?.status == 3 ? "#8BC34A" : // Close - light green text for Close
                                                                                                    TickeREtrievdatas?.status == 4 ? "#ED4C28" :
                                                                                                        TickeREtrievdatas?.status == 5 ? "#ED4C28" : TickeREtrievdatas?.status == 6 ? "#12B749" :
                                                                                                            TickeREtrievdatas?.status == 7 && "#ED4C28"
                                                                                    , // Default for Reopen - red text
                                                                                }}

                                                                            >

                                                                                {TickeREtrievdatas?.status == 0 ? "Open" :
                                                                                    TickeREtrievdatas?.status == 1 ? "In Progress" :
                                                                                        TickeREtrievdatas?.status == 2 ? "Review" :
                                                                                            TickeREtrievdatas?.status == 3 ? "Resolved" : TickeREtrievdatas?.status == 4 ? "Reopened" :
                                                                                                TickeREtrievdatas?.status == 5 ?
                                                                                                    "Reject" :
                                                                                                    TickeREtrievdatas?.status == 6 ?
                                                                                                        "Reject" : TickeREtrievdatas?.status == 7 && "Reject"

                                                                                }


                                                                            </span>




                                                                            {TickeREtrievdatas?.status != undefined && TickeREtrievdatas?.status != 3 ?
                                                                                <p className="HeaderoftheDatefileds Dashboardneardues">


                                                                                    {overdueFunctions(TickeREtrievdatas) != "Overdue" ?
                                                                                        <Stack spacing={2} direction="row">
                                                                                            <CircularProgress variant="determinate"
                                                                                                value={
                                                                                                    (() => {
                                                                                                        const response = overdueFunctions(TickeREtrievdatas); // Get the response
                                                                                                        let percentage = 0; // Default to 0


                                                                                                        if (response && response.includes("Minutes left")) {
                                                                                                            const [minutesText, ...rest] = response.split("Minutes left"); // Split the response
                                                                                                            // Extract the remaining time from the text (in minutes)
                                                                                                            const minutesLeft = Number(rest.join(""));
                                                                                                            const totalTAT = TickeREtrievdatas?.department_users?.l1_user_TAT || 100; // Default to 100 if no TAT is available

                                                                                                            console.log(minutesLeft, typeof minutesLeft, isNaN(minutesLeft), "oasiudopasidopaisd minutesLeft", totalTAT, minutesLeft, Math.min((minutesLeft / totalTAT) * 100, 100));


                                                                                                            // Ensure the minutesLeft is a valid number
                                                                                                            if (isNaN(minutesLeft)) {
                                                                                                                console.error("Invalid minutesLeft value:");
                                                                                                                return percentage; // Return 0 if invalid
                                                                                                            }


                                                                                                            if (isNaN(totalTAT)) {
                                                                                                                console.error("Invalid totalTAT value:", totalTAT);
                                                                                                                return percentage; // Return 0 if invalid
                                                                                                            }
                                                                                                            if (totalTAT === 1) {
                                                                                                                // Directly use minutesLeft as a percentage of 100
                                                                                                                percentage = Math.min(minutesLeft, 100);
                                                                                                            } else {
                                                                                                                // Use the usual percentage formula
                                                                                                                percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                                                                            }

                                                                                                            // percentage = Math.min((minutesLeft / totalTAT ) * 100, 100);
                                                                                                        }
                                                                                                        else if (response && response.includes("Hours left")) {
                                                                                                            const [minutesText, ...rest] = response.split("Hours left");
                                                                                                            const minutesLeft = parseInt(minutesText.trim(), 10);

                                                                                                            if (isNaN(minutesLeft)) {
                                                                                                                console.error("Invalid minutesLeft value:", minutesLeft);
                                                                                                                return percentage; // Return 0 if invalid
                                                                                                            }

                                                                                                            const totalTAT = TickeREtrievdatas?.department_users?.l1_user_TAT || 100;
                                                                                                            if (isNaN(totalTAT)) {
                                                                                                                console.error("Invalid totalTAT value:", totalTAT);
                                                                                                                return percentage; // Return 0 if invalid
                                                                                                            }

                                                                                                            percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                                                                        }

                                                                                                        else if (response && response.includes("Days left")) {
                                                                                                            const [minutesText, ...rest] = response.split("Days left");
                                                                                                            const minutesLeft = parseInt(minutesText.trim(), 10);
                                                                                                            if (isNaN(minutesLeft)) {
                                                                                                                console.error("Invalid minutesLeft value:", minutesLeft);
                                                                                                                return percentage; // Return 0 if invalid
                                                                                                            }

                                                                                                            const totalTAT = TickeREtrievdatas?.department_users?.l1_user_TAT || 100;
                                                                                                            if (isNaN(totalTAT)) {
                                                                                                                return percentage;
                                                                                                            }
                                                                                                            percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                                                                        }

                                                                                                        console.log(percentage, "aspdopasidoasd percentage", response);

                                                                                                        return percentage;
                                                                                                    })()
                                                                                                }
                                                                                                style={{
                                                                                                    borderRadius: "50%",
                                                                                                    width: "59px",
                                                                                                    height: "60px",
                                                                                                    background: "transparent", // Conditional background color based on the value
                                                                                                    // border: "2px solid", // Ensure a border is present
                                                                                                    borderColor: "#F26639",
                                                                                                    color: "#F26639",
                                                                                                    marginRight: "-16px !important"
                                                                                                    // color: 10 === 90 ? "#F26639" : "gray", // Conditional border color based on the value
                                                                                                    // borderColor: overdueFunctionspercentanges(item) >10 ? "#F26639" : "gray", // Conditional border color based on the value
                                                                                                }}

                                                                                                sx={{
                                                                                                    borderRadius: "50%",
                                                                                                    width: "55px",
                                                                                                    height: "55px",
                                                                                                    backgroundColor: "transparent", // Conditional background color
                                                                                                    // border: "2px solid", // Border width
                                                                                                    borderColor: 90 === 90 ? "#F26639" : "gray", // Conditional border color
                                                                                                }}

                                                                                            />

                                                                                            <span className="HeaderoftheDatefiledsNameDashboard">
                                                                                                {(() => {
                                                                                                    const response = overdueFunctions(TickeREtrievdatas); // Get the response

                                                                                                    if (response) {
                                                                                                        if (response.includes("Minutes left")) {
                                                                                                            const [minutesText, ...rest] = response.split("Minutes left"); // Split the response

                                                                                                            return <> <span>{rest.join("")}</span><span className="MinutesLeft">

                                                                                                                {"Minutes"}</span></>


                                                                                                        } else if (response.includes("Hours left")) {
                                                                                                            const [minutesText, ...rest] = response.split("Hours left"); // Split the response
                                                                                                            const daysLeft = parseInt(minutesText.trim(), 10); // Extract the days value


                                                                                                            return <> <span>{daysLeft}</span><span className="MinutesLeft">

                                                                                                                {"Hours"}</span></>
                                                                                                        } else if (response.includes("Days left")) {
                                                                                                            const [minutesText, ...rest] = response.split("Days left"); // Split the response
                                                                                                            const daysLeft = parseInt(minutesText.trim(), 10); // Extract the days value

                                                                                                            return <> <span>{daysLeft}</span><span className="MinutesLeft">

                                                                                                                {"Days"}</span></>

                                                                                                        } else if (response === "Overdue") {
                                                                                                            return <span className="OverdueText">Overdue</span>;
                                                                                                        }
                                                                                                    }

                                                                                                    return null; // Render nothing if response is not defined
                                                                                                })()}

                                                                                            </span>
                                                                                        </Stack>
                                                                                        :
                                                                                        <span className="OverdueTextticket">Overdue</span>}


                                                                                </p>
                                                                                : null}

                                                                        </div>

                                                                        {/* <TimelineExample /> */}

                                                                        <div className="timeline-containers timeline-containersprogress">


                                                                            {state.internalTicketTimeline.InternalDepartments_TicketsretrieveTimeline && Object.keys(state.internalTicketTimeline.InternalDepartments_TicketsretrieveTimeline).map((key, index) => {
                                                                                const item = state.internalTicketTimeline.InternalDepartments_TicketsretrieveTimeline[key]; // Get the status object (e.g., open, inprogress, etc.)
                                                                                const getStatusText = (statusObj, statusKey) => {
                                                                                    if (statusObj) {
                                                                                        return (
                                                                                            <>
                                                                                                <span>
                                                                                                    {statusObj.created_date
                                                                                                        ? `${new Date(statusObj.created_date).toLocaleDateString("en-GB", {
                                                                                                            day: "2-digit",
                                                                                                            month: "short",
                                                                                                            year: "numeric",
                                                                                                        }).replace(",", "")}`
                                                                                                        : " "}
                                                                                                </span>
                                                                                            </>
                                                                                        );
                                                                                    }

                                                                                };


                                                                                return (

                                                                                    <React.Fragment key={index}>
                                                                                        <div className={`timeline-item ${item?.created_date ? "active" : "NotactiveInBars"}`}>
                                                                                            <div className={`InnerTimelines ${item?.created_date ? "active" : ""}`}>
                                                                                                <div className="dot"></div>
                                                                                                <span>
                                                                                                    {/* {key == "completed" ? "Review" : key == "close" ? "Resolved" : capitalizeEachWord(key)} */}
                                                                                                    {item?.status != null &&
                                                                                                        capitalizeEachWord(item?.status)}


                                                                                                </span>
                                                                                            </div>
                                                                                            <div className={`timeline-line ${item?.created_date ? "active" : ""}`}></div>

                                                                                            <p className='CreatedDateList'>
                                                                                                <span>{getStatusText(item, key)}</span>

                                                                                                <span>{item.created_date ? extractTimeFromDate(item.created_date) : ""}</span>
                                                                                            </p>
                                                                                        </div>
                                                                                    </React.Fragment>

                                                                                );
                                                                            })}








                                                                        </div>
                                                                    </div>
                                                                </div>






                                                            </div>

                                                            <div className="card CardBox  collapseOnecards  shadow-sm  ">

                                                                <div className="card CardBox  collapseOnecards  shadow-sm  ">


                                                                    <div class="accordion" id="accordionExample" style={{ marginTop: "11px" }}>
                                                                        <div class="card  ">
                                                                            <div
                                                                                class="card-header InnerTicketAccordion"
                                                                                id="headingOne"
                                                                                data-bs-toggle="collapse"
                                                                                data-bs-target="#collapseOne"
                                                                                aria-expanded="true"
                                                                                aria-controls="collapseOne"
                                                                            >
                                                                                <h5 class="mb-0 HfiveHeaders">



                                                                                    <button
                                                                                        class="btn btn-link d-flex justify-content-between align-items-center"
                                                                                        type="button"
                                                                                    >


                                                                                        <span class="icon">
                                                                                            <img
                                                                                                src={tciketimgs}
                                                                                                style={{ marginRight: "12px", marginTop: "-2px" }}
                                                                                            />
                                                                                        </span>

                                                                                        Ticket ID - {TickeREtrievdatas?.ticket_number}

                                                                                    </button>

                                                                                    <span class="icon">
                                                                                        <img
                                                                                            src={dropdowns}
                                                                                        />
                                                                                    </span>
                                                                                </h5>
                                                                            </div>

                                                                            <div
                                                                                id="collapseOne"
                                                                                // class="collapse show"
                                                                                className={`collapse ${TickeREtrievdatas?.status == 2 ? "hide_ticket" : "show"}`}
                                                                                aria-labelledby="headingOne"
                                                                                data-bs-parent="#accordionExample"
                                                                            >
                                                                                <div class="card-body TicketCardAccordion">
                                                                                    <div className='card shadow-sm p-3 '>


                                                                                        <p className="mb-1 cardpara heaerspara">
                                                                                            <span className="ticketheader ticketheadercards">Ticket ID</span>
                                                                                            {TickeREtrievdatas?.ticket_number}
                                                                                        </p>

                                                                                        <p className="mb-1 cardpara heaerspara">
                                                                                            <span className="ticketheader ticketheadercards">Department</span>
                                                                                            <span className='IssueCategorylisted'>
                                                                                                {TickeREtrievdatas?.department_id?.department_name
                                                                                                    ? TickeREtrievdatas?.department_id?.department_name
                                                                                                    : "--"}
                                                                                            </span>
                                                                                        </p>
                                                                                        <p className="mb-1 cardpara heaerspara">
                                                                                            <span className="ticketheader ticketheadercards">Category</span>
                                                                                            {TickeREtrievdatas?.internal_category_id?.issue_category_id?.name
                                                                                                ? capitalizeEachWord(TickeREtrievdatas?.internal_category_id?.issue_category_id?.name.toLowerCase())
                                                                                                : "---"}
                                                                                        </p>
                                                                                        <p className="mb-1 cardpara heaerspara">
                                                                                            <span className="ticketheader ticketheadercards">Subcategory</span>
                                                                                            {TickeREtrievdatas?.internal_category_id?.name
                                                                                                ? capitalizeEachWord(TickeREtrievdatas?.internal_category_id?.name.toLowerCase())
                                                                                                : "---"}
                                                                                        </p>
                                                                                        <p className="mb-1 cardpara">
                                                                                            <span className="ticketheader ticketheadercards">Description</span>

                                                                                            <span className="ticketsinners">{TickeREtrievdatas?.remarks || "No description available"}</span>
                                                                                        </p>

                                                                                        <p className="mb-1 cardpara">
                                                                                            <span className='ticketheader ticketheadercards Attachmentviedetails '>Attachment</span>

                                                                                            {TickeREtrievdatas?.documents == undefined || TickeREtrievdatas?.documents == null || TickeREtrievdatas?.documents.length === 0 ? (
                                                                                                <p className='NoDouments'>No documents available</p>
                                                                                            ) : (
                                                                                                <div className="document-display">
                                                                                                    <div className="document-item">
                                                                                                        {/* Display only the first document */}
                                                                                                        {TickeREtrievdatas?.documents[0] && (
                                                                                                            <span className="attachments-list">
                                                                                                                <span className="document-info">
                                                                                                                    <img className="gallery-img" src={galleryimg2} alt="Gallery" />
                                                                                                                    {/* Document.{TickeREtrievdatas?.documents[0]?.split('.').pop()} */}
                                                                                                                    {TickeREtrievdatas.documents[0].split('/').pop()}
                                                                                                                </span>
                                                                                                                <span
                                                                                                                    className="download-options"
                                                                                                                    onClick={() => window.open(TickeREtrievdatas?.documents[0], '_blank')}
                                                                                                                >
                                                                                                                    <img src={downloadimg2} alt="Download" />
                                                                                                                </span>
                                                                                                            </span>
                                                                                                        )}


                                                                                                        {TickeREtrievdatas?.documents[1] && (
                                                                                                            <span className="attachments-list">
                                                                                                                <span className="document-info">
                                                                                                                    <img className="gallery-img" src={galleryimg2} alt="Gallery" />
                                                                                                                    {/* Document.{TickeREtrievdatas?.documents[1]?.split('.').pop()}  */}
                                                                                                                    {TickeREtrievdatas.documents[1].split('/').pop()}
                                                                                                                </span>
                                                                                                                <span
                                                                                                                    className="download-options"
                                                                                                                    onClick={() => window.open(TickeREtrievdatas?.documents[1], '_blank')}
                                                                                                                >
                                                                                                                    <img src={downloadimg2} alt="Download" />
                                                                                                                </span>
                                                                                                            </span>
                                                                                                        )}
                                                                                                    </div>

                                                                                                    {/* Show "+X" if there are more documents */}
                                                                                                    {TickeREtrievdatas?.documents.length > 2 && (
                                                                                                        <div className="more-documents"

                                                                                                            onClick={() => setModalOpen(true)}
                                                                                                        >
                                                                                                            +{TickeREtrievdatas?.documents.length - 2} more
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                            )}





                                                                                        </p>

                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>


                                                                    <div>

                                                                        <p className='TicketRemarksTviews'>

                                                                            <span className="ticketheader ticketheadercards">Remarks</span>

                                                                            <div className='ticket-activity'>
                                                                                <div className='Ticketviewexpands'>
                                                                                    {/* {state.commentsDatas.CommentsDatas.length > 0 && (  */}
                                                                                    <div className={`timeline ${TickeREtrievdatas?.status == 3 ? "timelinewidthchanges" : ""}`}
                                                                                        ref={timelineRefremarks}
                                                                                    >
                                                                                        {state.internalcommandticketgetdata.internaldepartmentticketgetdata != undefined &&
                                                                                            state.internalcommandticketgetdata.internaldepartmentticketgetdata.length > 0 ?

                                                                                            <>
                                                                                                {state.internalcommandticketgetdata.internaldepartmentticketgetdata != undefined &&
                                                                                                    state.internalcommandticketgetdata.internaldepartmentticketgetdata.length > 0 && state.internalcommandticketgetdata.internaldepartmentticketgetdata.map((item, index) => {
                                                                                                        const firstName = item.uds_user_id?.first_name ? item.uds_user_id?.first_name.toUpperCase() : "";
                                                                                                        const formattedName = firstName ? `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}` : "N/A";

                                                                                                        return (
                                                                                                            <>

                                                                                                                <div className="timeline-item"
                                                                                                                    // ref={Remarkesref}
                                                                                                                    ref={Remarkesref}
                                                                                                                >
                                                                                                                    <div className="timeline-icon TimeLinePersongIMGS">
                                                                                                                        {/* <img src={ticketactiveimgs} className='personImg' alt="" /> */}
                                                                                                                        <span>{item.uds_user_id?.first_name ? formattedName : item.client_user_id?.first_name ? formattedName : "Not mention"}                                                                                                                        </span>
                                                                                                                        {/* <img src={profile2} alt="User" className='personImg' /> */}
                                                                                                                    </div>

                                                                                                                    {state.internalcommandticketgetdata.internaldepartmentticketgetdata?.length &&
                                                                                                                        index + 1 !== state.internalcommandticketgetdata.internaldepartmentticketgetdata.length && (
                                                                                                                            <div className='Lineofnext'></div>
                                                                                                                        )
                                                                                                                    }
                                                                                                                    <div className="timeline-content">
                                                                                                                        <div className='EscalationPersondetails'>
                                                                                                                            {item.name ? <p className="message">

                                                                                                                                <p className="user-name">
                                                                                                                                    <span>
                                                                                                                                        {state.SideBarFiles.LoginIDs == item.uds_user_id?.id ? "You" :
                                                                                                                                            item.uds_user_id?.first_name ? capitalizeFirstLetter(item.uds_user_id?.first_name) :

                                                                                                                                                item.client_user_id?.first_name ?
                                                                                                                                                    capitalizeFirstLetter(item.client_user_id?.first_name) :
                                                                                                                                                    "Not mention"}



                                                                                                                                        {(state.SideBarFiles.LoginIDs !== item.uds_user_id?.id && item.client_user_id?.first_name) ||
                                                                                                                                            item.uds_user_id?.first_name ? (
                                                                                                                                            <>
                                                                                                                                                {state.SideBarFiles.LoginIDs !== item.uds_user_id?.id ? (
                                                                                                                                                    <button className='MentiontheUSer'>
                                                                                                                                                        {state.SideBarFiles.LoginIDs === item.uds_user_id?.id
                                                                                                                                                            ? ""
                                                                                                                                                            : item.uds_user_id?.first_name
                                                                                                                                                                ? "UDS"
                                                                                                                                                                : item.client_user_id?.first_name
                                                                                                                                                                    ? "CLIENT"
                                                                                                                                                                    : ""}
                                                                                                                                                    </button>
                                                                                                                                                ) : null}
                                                                                                                                            </>
                                                                                                                                        ) : null}

                                                                                                                                    </span>

                                                                                                                                    <span className="timestamp">{item.created_at ? formatedDateList(item.created_at) : ""}</span>

                                                                                                                                </p>


                                                                                                                                <p className="MessageBoxes">
                                                                                                                                    {item.name ? capitalizeFirstLetter(item.name) : ""}
                                                                                                                                </p>                                                                                                                            </p>
                                                                                                                                : null}
                                                                                                                        </div>
                                                                                                                        <>



                                                                                                                            {/* {item.documents !== undefined && item.documents !== null && item.documents.length > 0 ? (
                                                                                                                                <div className="attachment">
                                                                                                                                    <img src={galleyimg} alt="Attachment" />
                                                                                                                                    <span>{item.documents.length} File Attached</span>

                                                                                                                                    {item.documents.map((document, index) => (
                                                                                                                                        <button
                                                                                                                                            key={index}
                                                                                                                                            className="download-btn"
                                                                                                                                            onClick={() => downloadAll(item.documents)}

                                                                                                                                        >
                                                                                                                                            <img src={downloadimg} alt="Download" />
                                                                                                                                        </button>
                                                                                                                                    ))}
                                                                                                                                </div>
                                                                                                                            ) : null} */}


                                                                                                                            {Array.isArray(item.documents) && item.documents.length > 0 ? (
                                                                                                                                <div className="attachment">
                                                                                                                                    <img src={galleyimg} alt="Attachment" />
                                                                                                                                    <span>{item.documents.length} File Attached</span>

                                                                                                                                    {item.documents.map((document, index) => (
                                                                                                                                        <button
                                                                                                                                            key={index}
                                                                                                                                            className="download-btn"
                                                                                                                                            onClick={() => downloadAll(item.documents)}
                                                                                                                                        >
                                                                                                                                            <img src={downloadimg} alt="Download" />
                                                                                                                                        </button>
                                                                                                                                    ))}
                                                                                                                                </div>
                                                                                                                            ) : null}


                                                                                                                        </>

                                                                                                                    </div>
                                                                                                                </div>





                                                                                                            </>
                                                                                                        )
                                                                                                    })}

                                                                                            </>
                                                                                            :

                                                                                            <><div className='CommunicationAlters'>
                                                                                                <p>
                                                                                                    No message yet
                                                                                                </p>
                                                                                            </div></>

                                                                                        }


                                                                                    </div>


                                                                                </div>
                                                                            </div>

                                                                        </p>
                                                                    </div>

                                                                </div>

                                                            </div>
                                                        </div>

                                                    </div>







                                                </div>

                                                <div className="col-5 PartTwoOFTicketDetails">
                                                    <div className='Innerticketview5'>
                                                        <div className="  EScalationlevel  mb-4">
                                                            <div className="card  p-3" >
                                                                <div className='HeaderTimelines HeaderOFEscalationlevel'>
                                                                    <div className='HeaderHeading'>
                                                                        <h5>Escalation Level</h5>

                                                                    </div>



                                                                </div>
                                                                {Escalationpopup && (
                                                                    <div className='ProgressInoverall'>

                                                                        {state.ticketexcalationrecordoflist?.ticketescalationdatas &&
                                                                            state.ticketexcalationrecordoflist.ticketescalationdatas != undefined &&
                                                                            state.ticketexcalationrecordoflist.ticketescalationdatas.length > 0 &&
                                                                            state.ticketexcalationrecordoflist.ticketescalationdatas.map((escalationclienttickets) => {

                                                                                return (
                                                                                    <div className={`Internalticketserializers`}>
                                                                                        <div className='departmentNames' style={{ borderRight: "1px solid #D9D9D9" }} >
                                                                                            {/* <p>{capitalizeEachWord(escalationclienttickets?.clientsub_category_id?.name.toLowerCase())}</p> */}
                                                                                            <p>{"Ops"}</p>

                                                                                        </div>
                                                                                        <div className="progress-TIMELINE" style={{ borderTop: "1px solid #D9D9D9", borderRight: "1px solid #D9D9D9" }}>
                                                                                            <div className='InnerMattersLEVEL'>
                                                                                                <div className='Levelofpersons'>
                                                                                                    <div className={`timeline-icon ${escalationclienttickets?.overdue_stage == "l1" ? "TimeLinePersongIMGS" :
                                                                                                        escalationclienttickets?.overdue_stage == "l2" ?
                                                                                                            "TimeLinePersongIMGS" : escalationclienttickets?.overdue_stage == "l3" ?
                                                                                                                "TimeLinePersongIMGS" : "TimeLinePersongNON"}`}>
                                                                                                        L1
                                                                                                    </div>
                                                                                                    <div class="timeline-line"></div>
                                                                                                </div>


                                                                                                <div className='Holdtheusers'>


                                                                                                    {escalationclienttickets?.l1_users &&
                                                                                                        escalationclienttickets.l1_users.map((item, index) => {
                                                                                                            const firstName = item.first_name.toUpperCase(); // Convert to uppercase for consistency
                                                                                                            const formattedName = `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}`; // Get first and last letter

                                                                                                            return (
                                                                                                                <div className='PersonsNamesHeaders'>
                                                                                                                    <span
                                                                                                                        key={index}
                                                                                                                        className="PersonsNames"
                                                                                                                        onMouseEnter={() => setShowTooltip(index)}
                                                                                                                        onMouseLeave={() => setShowTooltip(null)}
                                                                                                                    >
                                                                                                                        {formattedName}
                                                                                                                        {showTooltip === index && (
                                                                                                                            <div className="custom-tooltip">
                                                                                                                                <span>{item.first_name || 'No Role Available'}</span>
                                                                                                                            </div>
                                                                                                                        )}
                                                                                                                    </span>

                                                                                                                    {escalationclienttickets.l1_users.length == 1 ?
                                                                                                                        <p className='FirstNameCapitals'>{item.first_name && capitalizeEachWord(item.first_name)}</p>
                                                                                                                        : null}
                                                                                                                </div>
                                                                                                            );
                                                                                                        })}


                                                                                                </div>
                                                                                            </div>

                                                                                            <div className='InnerMattersLEVEL'>

                                                                                                <div className='Levelofpersons'>
                                                                                                    <div className={`timeline-icon ${escalationclienttickets?.overdue_stage == "l2" ?
                                                                                                        "TimeLinePersongIMGS" : escalationclienttickets?.overdue_stage == "l3" ?
                                                                                                            "TimeLinePersongIMGS" : "TimeLinePersongNON"}`}>
                                                                                                        L2
                                                                                                    </div>
                                                                                                    <div class="timeline-line"></div>
                                                                                                </div>
                                                                                                <div className='InnerPersonslist'>

                                                                                                    <div className='Holdtheusers'>

                                                                                                        {escalationclienttickets?.l2_users &&
                                                                                                            escalationclienttickets.l2_users.map((item, index) => {
                                                                                                                const firstName = item.first_name.toUpperCase(); // Convert to uppercase for consistency
                                                                                                                const formattedName = `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}`; // Get first and last letter

                                                                                                                return (
                                                                                                                    <div className='PersonsNamesHeaders'>

                                                                                                                        <span
                                                                                                                            key={index}
                                                                                                                            className="PersonsNames PersonsNames3"
                                                                                                                        // onMouseEnter={() => setShowTooltipone(index)}
                                                                                                                        // onMouseLeave={() => setShowTooltipone(null)}


                                                                                                                        >
                                                                                                                            {formattedName}
                                                                                                                            {/* {showTooltipone === index && (
                                                                                                                    <div className="custom-tooltip">
                                                                                                                        <span>  {item.first_name || 'No Role Available'}</span>
                                                                                                                    </div>
                                                                                                                )} */}


                                                                                                                        </span>
                                                                                                                        {escalationclienttickets.l2_users.length == 1 ?

                                                                                                                            <p className='FirstNameCapitals'>{item.first_name && capitalizeEachWord(item.first_name)}</p>
                                                                                                                            : null}
                                                                                                                    </div>
                                                                                                                );
                                                                                                            })}
                                                                                                    </div>

                                                                                                </div>


                                                                                            </div>


                                                                                            <div className='InnerMattersLEVEL'>
                                                                                                <div className='Levelofpersons'>
                                                                                                    <div className={`timeline-icon ${escalationclienttickets?.overdue_stage == "l3" ? "TimeLinePersongIMGS" :
                                                                                                        "TimeLinePersongNON"}`}>
                                                                                                        L3
                                                                                                    </div>
                                                                                                </div>

                                                                                                <div className='Holdtheusers'>

                                                                                                    {escalationclienttickets?.l3_users &&
                                                                                                        escalationclienttickets.l3_users.map((item, index) => {
                                                                                                            const firstName = item.first_name.toUpperCase(); // Convert to uppercase for consistency
                                                                                                            const formattedName = `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}`; // Get first and last letter

                                                                                                            return (
                                                                                                                <div className='PersonsNamesHeaders'>

                                                                                                                    <span
                                                                                                                        key={index}
                                                                                                                        className="PersonsNames PersonsNames4"
                                                                                                                    // onMouseEnter={() => setShowTooltiptwo(index)}
                                                                                                                    // onMouseLeave={() => setShowTooltiptwo(null)}


                                                                                                                    >
                                                                                                                        {formattedName}
                                                                                                                        {/* {showTooltiptwo === index && (
                                                                                                                <div className="custom-tooltip">
                                                                                                                    <span>  {capitalizeEachWord(item.first_name) || 'No Role Available'}</span>
                                                                                                                </div>
                                                                                                            )} */}
                                                                                                                    </span>
                                                                                                                    {escalationclienttickets.l3_users.length == 1 ?

                                                                                                                        <p className='FirstNameCapitals'


                                                                                                                        >{item.first_name && capitalizeEachWord(item.first_name)}</p>
                                                                                                                        : null}
                                                                                                                </div>
                                                                                                            );
                                                                                                        })}



                                                                                                </div>
                                                                                            </div>



                                                                                        </div>
                                                                                    </div>
                                                                                )
                                                                            }
                                                                            )}


                                                                        {/* {state.ticketexcalationrecordoflist?.ticketescalationdatas &&
                                                                            state.ticketexcalationrecordoflist.ticketescalationdatas != undefined &&
                                                                            state.ticketexcalationrecordoflist.ticketescalationdatas.length > 0 &&
                                                                            state.ticketexcalationrecordoflist.ticketescalationdatas.map((escalations) => {

                                                                                return (
                                                                                    <>
                                                                                        {escalations &&
                                                                                            escalations.internal_ticket_serializer != undefined &&
                                                                                            escalations.internal_ticket_serializer.length > 0 &&
                                                                                            escalations.internal_ticket_serializer.map((item, index, array) => {
                                                                                                return (
                                                                                                    <>
                                                                                                        <div className={`${escalations.internal_ticket_serializer.length > 0 ? "Internalticketserializers" : "Internalticketserializersnot"}`}>
                                                                                                            <div className='departmentNames'>
                                                                                                                <p>{"Ops"}</p>
                                                                                                            </div>
                                                                                                            <div
                                                                                                                // className="progress-TIMELINE innerescalationlisted"
                                                                                                                className={`progress-TIMELINE innerescalationlisted ${index !== array.length - 1 ? "border-right" : ""
                                                                                                                    }`}
                                                                                                            >
                                                                                                                <div className='InnerMattersLEVEL'>
                                                                                                                    <div className='Levelofpersons'>
                                                                                                                        {item?.l1_users != undefined && item?.l1_users != null && item?.l1_users.length > 0 ?
                                                                                                                            <>
                                                                                                                                <div className={`timeline-icon ${item?.overdue_stage == "l1" ? "TimeLinePersongIMGS" :
                                                                                                                                    item?.overdue_stage == "l2" ?
                                                                                                                                        "TimeLinePersongIMGS" : item?.overdue_stage == "l3" ?
                                                                                                                                            "TimeLinePersongIMGS" : "TimeLinePersongNON"}`}>
                                                                                                                                    L1
                                                                                                                                </div>
                                                                                                                                <div class="timeline-line"></div>
                                                                                                                            </>
                                                                                                                            : null}
                                                                                                                    </div>


                                                                                                                    <div className='Holdtheusers'>


                                                                                                                        {item?.l1_users != undefined && item?.l1_users.length > 0 &&
                                                                                                                            item.l1_users.map((itemone, indexone) => {
                                                                                                                                const firstName = itemone.first_name.toUpperCase(); // Convert to uppercase for consistency
                                                                                                                                const formattedName = `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}`; // Get first and last letter
                                                                                                                                console.log(itemone, "asodkapskdpasd itemone", firstName, formattedName);

                                                                                                                                return (
                                                                                                                                    <div className='PersonsNamesHeaders'>
                                                                                                                                        <span
                                                                                                                                            key={indexone}
                                                                                                                                            className="PersonsNames"
                                                                                                                                        // onMouseEnter={() => setShowTooltip(indexone)}
                                                                                                                                        // onMouseLeave={() => setShowTooltip(null)}
                                                                                                                                        >
                                                                                                                                            {formattedName}
                                                                                                                                           
                                                                                                                                        </span>

                                                                                                                                        {itemone.l1_users != undefined && itemone.l1_users != null && itemone.l1_users.length == 1 ?
                                                                                                                                            <p className='FirstNameCapitals'>{itemone.first_name != null && itemone.first_name && capitalizeEachWord(itemone.first_name)}</p>
                                                                                                                                            : null}
                                                                                                                                    </div>

                                                                                                                                );
                                                                                                                            })}


                                                                                                                    </div>
                                                                                                                </div>

                                                                                                                <div className='InnerMattersLEVEL'>

                                                                                                                    <div className='Levelofpersons'>
                                                                                                                        {item?.l2_users != undefined && item?.l2_users != null && item?.l2_users.length > 0 ?

                                                                                                                            <>

                                                                                                                                <div className={`timeline-icon ${item?.overdue_stage == "l2" ?
                                                                                                                                    "TimeLinePersongIMGS" : item?.overdue_stage == "l3" ?
                                                                                                                                        "TimeLinePersongIMGS" : "TimeLinePersongNON"}`}>
                                                                                                                                    L2
                                                                                                                                </div>
                                                                                                                                <div class="timeline-line"></div>
                                                                                                                            </>
                                                                                                                            : null}

                                                                                                                    </div>
                                                                                                                    <div className='InnerPersonslist'>

                                                                                                                        <div className='Holdtheusers'>

                                                                                                                            {item?.l2_users != undefined && item?.l2_users != null && item?.l2_users &&
                                                                                                                                item.l2_users.map((itemUsertwo, indextwousers) => {
                                                                                                                                    const firstName = itemUsertwo.first_name.toUpperCase(); // Convert to uppercase for consistency
                                                                                                                                    const formattedName = `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}`; // Get first and last letter

                                                                                                                                    return (
                                                                                                                                        <div className='PersonsNamesHeaders'>

                                                                                                                                            <span
                                                                                                                                                key={indextwousers}
                                                                                                                                                className="PersonsNames PersonsNames3"
                                                                                                                                            // onMouseEnter={() => setShowTooltipone(indextwousers)}
                                                                                                                                            // onMouseLeave={() => setShowTooltipone(null)}


                                                                                                                                            >
                                                                                                                                                {formattedName}
                                                                                                                                                
                                                                                                                                            </span>
                                                                                                                                            {itemUsertwo.l2_users != undefined && itemUsertwo.l2_users != null && itemUsertwo.l2_users.length == 1 ?
                                                                                                                                                <p className='FirstNameCapitals'>{itemUsertwo.first_name && capitalizeEachWord(itemUsertwo.first_name)}</p>
                                                                                                                                                : null}
                                                                                                                                        </div>
                                                                                                                                    );
                                                                                                                                })}
                                                                                                                        </div>

                                                                                                                    </div>


                                                                                                                </div>


                                                                                                                <div className='InnerMattersLEVEL'>
                                                                                                                    <div className='Levelofpersons'>
                                                                                                                        {item?.l3_users != undefined && item?.l3_users != null && item?.l3_users.length > 0 ?
                                                                                                                            <>

                                                                                                                                <div className={`timeline-icon ${item?.overdue_stage == "l3" ? "TimeLinePersongIMGS" :
                                                                                                                                    "TimeLinePersongNON"}`}>
                                                                                                                                    L3
                                                                                                                                </div>
                                                                                                                            </>

                                                                                                                            : null}
                                                                                                                    </div>

                                                                                                                    <div className='Holdtheusers'>

                                                                                                                        {item?.l3_users &&
                                                                                                                            item.l3_users.map((itemthree, indexthrid) => {
                                                                                                                                const firstName = itemthree.first_name.toUpperCase(); // Convert to uppercase for consistency
                                                                                                                                const formattedName = `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}`; // Get first and last letter

                                                                                                                                return (
                                                                                                                                    <div className='PersonsNamesHeaders'>

                                                                                                                                        <span
                                                                                                                                            key={indexthrid}
                                                                                                                                            className="PersonsNames PersonsNames4"
                                                                                                                                        // onMouseEnter={() => setShowTooltiptwo(indexthrid)}
                                                                                                                                        // onMouseLeave={() => setShowTooltiptwo(null)}


                                                                                                                                        >
                                                                                                                                            {formattedName}

                                                                                                                                        </span>
                                                                                                                                        {itemthree.l3_users != undefined && itemthree.l3_users.length == 1 ?

                                                                                                                                            <p className='FirstNameCapitals'


                                                                                                                                            >{itemthree.first_name && capitalizeEachWord(itemthree.first_name)}</p>
                                                                                                                                            : null}
                                                                                                                                    </div>
                                                                                                                                );
                                                                                                                            })}



                                                                                                                    </div>
                                                                                                                </div>



                                                                                                            </div>

                                                                                                        </div >
                                                                                                    </>
                                                                                                )
                                                                                            })}

                                                                                    </>
                                                                                )
                                                                            })} */}


                                                                        {state.ticketexcalationrecordoflist?.ticketescalationdatas &&
                                                                            state.ticketexcalationrecordoflist.ticketescalationdatas != undefined &&
                                                                            state.ticketexcalationrecordoflist.ticketescalationdatas.length > 0 &&
                                                                            state.ticketexcalationrecordoflist.ticketescalationdatas.map((escalations) => {

                                                                                return (
                                                                                    <>
                                                                                        {escalations &&
                                                                                            escalations.internal_ticket_serializer != undefined &&
                                                                                            escalations.internal_ticket_serializer.length > 0 &&
                                                                                            // escalations.internal_ticket_serializer.map((item, index, array) => {
                                                                                            //     return (
                                                                                            <>
                                                                                                <div className={`${escalations.internal_ticket_serializer.length > 1 ? "Internalticketserializers" : "Internalticketserializersnot"}`}>
                                                                                                    <div className='departmentNames'>
                                                                                                    <p>{`${escalations.internal_ticket_serializer[0]?.department_id?.department_name}`}</p>
                                                                                                        {/* <p>{`${capitalizeEachWord(escalations.internal_ticket_serializer[0]?.department_id?.department_name.toLowerCase())} Department`}</p> */}
                                                                                                    </div>
                                                                                                    <div
                                                                                                        className={`progress-TIMELINE innerescalationlisted `}
                                                                                                    >
                                                                                                        <div className='InnerMattersLEVEL'>
                                                                                                            <div className='Levelofpersons'>
                                                                                                                {escalations.internal_ticket_serializer[0]?.l1_users != undefined && escalations.internal_ticket_serializer[0]?.l1_users != null && escalations.internal_ticket_serializer[0]?.l1_users.length > 0 ?
                                                                                                                    <>
                                                                                                                        <div className={`timeline-icon ${escalations.internal_ticket_serializer[0]?.overdue_stage == "l1" ? "TimeLinePersongIMGS" :
                                                                                                                            escalations.internal_ticket_serializer[0]?.overdue_stage == "l2" ?
                                                                                                                                "TimeLinePersongIMGS" : escalations.internal_ticket_serializer[0]?.overdue_stage == "l3" ?
                                                                                                                                    "TimeLinePersongIMGS" : "TimeLinePersongNON"}`}>
                                                                                                                            L1
                                                                                                                        </div>
                                                                                                                        <div class="timeline-line"></div>
                                                                                                                    </>
                                                                                                                    : null}
                                                                                                            </div>


                                                                                                            <div className='Holdtheusers'>


                                                                                                                {escalations.internal_ticket_serializer[0]?.l1_users != undefined && escalations.internal_ticket_serializer[0]?.l1_users.length > 0 &&
                                                                                                                    escalations.internal_ticket_serializer[0].l1_users.map((itemone, indexone) => {
                                                                                                                        const firstName = itemone.first_name.toUpperCase(); // Convert to uppercase for consistency
                                                                                                                        const formattedName = `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}`; // Get first and last letter
                                                                                                                        // console.log(itemone, "asodkapskdpasd itemone", firstName, formattedName);

                                                                                                                        return (
                                                                                                                            <div className='PersonsNamesHeaders'>
                                                                                                                                <span
                                                                                                                                    key={indexone}
                                                                                                                                    className="PersonsNames"
                                                                                                                                >
                                                                                                                                    {formattedName}

                                                                                                                                </span>

                                                                                                                                {itemone.first_name != undefined && itemone.first_name != null && itemone.first_name ?
                                                                                                                                    <p className='FirstNameCapitals'>{itemone.first_name != null && itemone.first_name && capitalizeEachWord(itemone.first_name)}</p>
                                                                                                                                    : null}
                                                                                                                            </div>

                                                                                                                        );
                                                                                                                    })}


                                                                                                            </div>
                                                                                                        </div>

                                                                                                        <div className='InnerMattersLEVEL'>

                                                                                                            <div className='Levelofpersons'>
                                                                                                                {escalations.internal_ticket_serializer[0]?.l2_users != undefined && escalations.internal_ticket_serializer[0]?.l2_users != null && escalations.internal_ticket_serializer[0]?.l2_users.length > 0 ?

                                                                                                                    <>

                                                                                                                        <div className={`timeline-icon ${escalations.internal_ticket_serializer[0]?.overdue_stage == "l2" ?
                                                                                                                            "TimeLinePersongIMGS" : escalations.internal_ticket_serializer[0]?.overdue_stage == "l3" ?
                                                                                                                                "TimeLinePersongIMGS" : "TimeLinePersongNON"}`}>
                                                                                                                            L2
                                                                                                                        </div>
                                                                                                                        <div class="timeline-line"></div>
                                                                                                                    </>
                                                                                                                    : null}

                                                                                                            </div>
                                                                                                            <div className='InnerPersonslist'>

                                                                                                                <div className='Holdtheusers'>

                                                                                                                    {escalations.internal_ticket_serializer[0]?.l2_users != undefined && escalations.internal_ticket_serializer[0]?.l2_users != null && escalations.internal_ticket_serializer[0]?.l2_users &&
                                                                                                                        escalations.internal_ticket_serializer[0].l2_users.map((itemUsertwo, indextwousers) => {
                                                                                                                            const firstName = itemUsertwo.first_name.toUpperCase(); // Convert to uppercase for consistency
                                                                                                                            const formattedName = `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}`; // Get first and last letter

                                                                                                                            return (
                                                                                                                                <div className='PersonsNamesHeaders'>

                                                                                                                                    <span
                                                                                                                                        key={indextwousers}
                                                                                                                                        className="PersonsNames PersonsNames3"

                                                                                                                                    >
                                                                                                                                        {formattedName}

                                                                                                                                    </span>
                                                                                                                                    {itemUsertwo.first_name != undefined && itemUsertwo.first_name != null && itemUsertwo.first_name ?
                                                                                                                                        <p className='FirstNameCapitals'>{itemUsertwo.first_name && capitalizeEachWord(itemUsertwo.first_name)}</p>
                                                                                                                                        : null}
                                                                                                                                </div>
                                                                                                                            );
                                                                                                                        })}
                                                                                                                </div>

                                                                                                            </div>


                                                                                                        </div>


                                                                                                        <div className='InnerMattersLEVEL'>
                                                                                                            <div className='Levelofpersons'>
                                                                                                                {escalations.internal_ticket_serializer[0]?.l3_users != undefined && escalations.internal_ticket_serializer[0]?.l3_users != null && escalations.internal_ticket_serializer[0]?.l3_users.length > 0 ?
                                                                                                                    <>

                                                                                                                        <div className={`timeline-icon ${escalations.internal_ticket_serializer[0]?.overdue_stage == "l3" ? "TimeLinePersongIMGS" :
                                                                                                                            "TimeLinePersongNON"}`}>
                                                                                                                            L3
                                                                                                                        </div>
                                                                                                                    </>

                                                                                                                    : null}
                                                                                                            </div>

                                                                                                            <div className='Holdtheusers'>

                                                                                                                {escalations.internal_ticket_serializer[0]?.l3_users &&
                                                                                                                    escalations.internal_ticket_serializer[0].l3_users.map((itemthree, indexthrid) => {
                                                                                                                        const firstName = itemthree.first_name.toUpperCase(); // Convert to uppercase for consistency
                                                                                                                        const formattedName = `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}`; // Get first and last letter

                                                                                                                        return (
                                                                                                                            <div className='PersonsNamesHeaders'>

                                                                                                                                <span
                                                                                                                                    key={indexthrid}
                                                                                                                                    className="PersonsNames PersonsNames4"


                                                                                                                                >
                                                                                                                                    {formattedName}

                                                                                                                                </span>
                                                                                                                                {itemthree.first_name != undefined && itemthree.first_name ?

                                                                                                                                    <p className='FirstNameCapitals'
                                                                                                                                    >{itemthree.first_name && capitalizeEachWord(itemthree.first_name)}</p>
                                                                                                                                    : null}                            </div>
                                                                                                                        );
                                                                                                                    })}



                                                                                                            </div>
                                                                                                        </div>



                                                                                                    </div>

                                                                                                </div >
                                                                                            </>
                                                                                            //     )
                                                                                            // })}
                                                                                        }

                                                                                    </>
                                                                                )
                                                                            })}


                                                                    </div>
                                                                )}


                                                            </div>

                                                        </div>

                                                        <div className=" Recentcard2 ">

                                                            <div className="ticket-activity container">
                                                                <div className='ToggleOFTicketActiveTicketView'>

                                                                    <ul className="nav nav-tabs" role="tablist">
                                                                        <li className="nav-item" role="presentation">
                                                                            <button

                                                                                className={`  nav-link  ${state.FormsIDList.ActiveTabs == 4 ? "active" : ""
                                                                                    }`}
                                                                                id="ex3-tab-4"
                                                                                data-bs-toggle="tab"
                                                                                href="#ex3-tabs-4"
                                                                                role="tab"
                                                                                aria-controls="ex3-tabs-1"
                                                                                aria-selected={state.FormsIDList.ActiveTabs == 4}
                                                                                onClick={() => {
                                                                                    dispatch(SetActiveTabs(4));

                                                                                }}
                                                                            >
                                                                                Ticket Journey
                                                                            </button>
                                                                        </li>


                                                                        <li className="nav-item" role="presentation">
                                                                            <button

                                                                                className={`  nav-link  ${state.FormsIDList.ActiveTabs == 1 ? "active" : ""
                                                                                    }`}
                                                                                id="ex3-tab-1"
                                                                                data-bs-toggle="tab"
                                                                                href="#ex3-tabs-1"
                                                                                role="tab"
                                                                                aria-controls="ex3-tabs-1"
                                                                                aria-selected={state.FormsIDList.ActiveTabs == 1}
                                                                                onClick={() => {
                                                                                    dispatch(SetActiveTabs(1));

                                                                                }}
                                                                            >
                                                                                Chat
                                                                            </button>
                                                                        </li>


                                                                        {state.internalTicketFeedBack.InternalDepartments_TicketsFeedback != undefined && state.internalTicketFeedBack.InternalDepartments_TicketsFeedback.length > 0 ?


                                                                            <li className="nav-item" role="presentation">

                                                                                <button
                                                                                    className={`   nav-link  ${state.FormsIDList.ActiveTabs == 2 ? "active" : ""
                                                                                        }`}
                                                                                    id="ex3-tab-2"
                                                                                    data-bs-toggle="tab"
                                                                                    href="#ex3-tabs-2"
                                                                                    role="tab"
                                                                                    aria-controls="ex3-tabs-2"
                                                                                    aria-selected={state.FormsIDList.ActiveTabs == 2}
                                                                                    onClick={() => {
                                                                                        dispatch(SetActiveTabs(2));

                                                                                    }}
                                                                                >Client Feedback</button>
                                                                            </li>
                                                                            : null}

                                                                    </ul>
                                                                </div>


                                                                <>
                                                                    <div className="tab-content" id="ex2-content">



                                                                        <div className={`  tab-pane fade show Ticketviewexpands   ${state.FormsIDList.ActiveTabs == 4
                                                                            ? "active "
                                                                            : ""
                                                                            }`}
                                                                            id="ex3-tabs-4"
                                                                            role="tabpanel"
                                                                            aria-labelledby="ex3-tab-4">




                                                                            <div className={`timeline timelineTicketListedRightside ${TickeREtrievdatas?.status == 3 ? "timelinewidthchanges ForStatusResolved" : ""}`}
                                                                                ref={timelineRef}
                                                                            >
                                                                                {state.TicketJournydatasofinternlandcient.ticketJourneyforinternal != undefined &&
                                                                                    state.TicketJournydatasofinternlandcient.ticketJourneyforinternal.length > 0 ?
                                                                                    <>
                                                                                        {state.TicketJournydatasofinternlandcient.ticketJourneyforinternal != undefined &&
                                                                                            state.TicketJournydatasofinternlandcient.ticketJourneyforinternal.length > 0 && state.TicketJournydatasofinternlandcient.ticketJourneyforinternal.map((item, index) => {
                                                                                                console.log(state.TicketJournydatasofinternlandcient.ticketJourneyforinternal.length, "Saidjopsadosdoisad oasid",


                                                                                                    state.TicketJournydatasofinternlandcient.ticketJourneyforinternal,
                                                                                                );
                                                                                                const firstName = item.uds_user_id?.first_name ? item.uds_user_id?.first_name.toUpperCase() : "";
                                                                                                const formattedName = firstName ? `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}` : "N/A";
                                                                                                const ticketImages = [ticketJourneyimg1, ticketJourneyimg2];


                                                                                                return (
                                                                                                    <>

                                                                                                        {item.name == item.description ?

                                                                                                            <div className='Movedrecords' key={index}>
                                                                                                                <div className='Arrowudsticketjouneryicons'>
                                                                                                                    {/* <img src={ticketactiveimgs} /> */}
                                                                                                                    <img src={index == 0 ? ticketJourneyimg1 : ticketJourneyimg2 } />
                                                                                                                    {/* <img src={ticketImages[index % ticketImages.length]} alt="Journey Icon" /> */}
                                                                                                                    </div>
                                                                                                                {index + 1 == state.TicketJournydatasofinternlandcient.ticketJourneyforinternal.length ? null : (
                                                                                                                    <>
                                                                                                                        <div className="Lineofnext"></div>
                                                                                                                    </>
                                                                                                                )}

                                                                                                                <div className='Movedrecordsdetails'>

                                                                                                                    {/* <p><span className="timestampcreated">{item.created_at ? formatedDateList(item.created_at) : ""}</span></p> */}
                                                                                                                    <>
                                                                                                                        {

                                                                                                                            <div className='TicketJouryneactives'>

                                                                                                                                <div className='innerdetailsofticketviewed'>

                                                                                                                                    <span className='TicketDetailsContent'>
                                                                                                                                        {item.name}
                                                                                                                                    </span>

                                                                                                                                    <span className="timestampcreatedticketjounery ">
                                                                                                                                        {item.created_at
                                                                                                                                            ? formatedDateListwithtime(item.created_at) : ""}

                                                                                                                                    </span>


                                                                                                                                </div>

                                                                                                                                <div className="TicketDetailsOfStatements">
                                                                                                                                {item.status === "0" ? `Created by ${item.uds_user_id && item.uds_user_id?.first_name ? item.uds_user_id?.first_name : ""} (${item.uds_user_id ? item.uds_user_id?.user_role?.role : ""}) ` :
                                                                                                                                        item.status === "1" ? `In Progress by ${item.uds_user_id && item.uds_user_id?.first_name ? item.uds_user_id?.first_name : ""} (${item.uds_user_id ? item.uds_user_id?.user_role?.role : ""}) ` :
                                                                                                                                            item.status === "2" ? `Review by ${item.uds_user_id && item.uds_user_id?.first_name ? item.uds_user_id?.first_name : ""} (${item.uds_user_id ? item.uds_user_id?.user_role?.role : ""}) ` :
                                                                                                                                                item.status === "3" ? `Resolved by ${item.uds_user_id && item.uds_user_id?.first_name ? item.uds_user_id?.first_name : ""} (${item.uds_user_id ? item.uds_user_id?.user_role?.role : ""}) ` :
                                                                                                                                                    item.status === "4" ? `Reopened by ${item.uds_user_id && item.uds_user_id?.first_name ? item.uds_user_id?.first_name : ""} (${item.uds_user_id ? item.uds_user_id?.user_role?.role : ""}) ` :
                                                                                                                                                        item.status === "5" ? `Rejected by ${item.uds_user_id && item.uds_user_id?.first_name ? item.uds_user_id?.first_name : ""} (${item.uds_user_id ? item.uds_user_id?.user_role?.role : ""}) ` :
                                                                                                                                                            item.status === "6" ? `Assigned by ${item.uds_user_id && item.uds_user_id?.first_name ? item.uds_user_id?.first_name : ""} (${item.uds_user_id ? item.uds_user_id?.user_role?.role : ""}) ` :
                                                                                                                                                                item.status === "7" && `Reassigned by ${item.uds_user_id && item.uds_user_id?.first_name ? item.uds_user_id?.first_name : ""} (${item.uds_user_id ? item.uds_user_id?.user_role?.role : ""}) `}
                                                                                                                                </div>


                                                                                                                            </div>

                                                                                                                        }
                                                                                                                    </>




                                                                                                                </div>


                                                                                                            </div>
                                                                                                            :

                                                                                                            <><div className='CommunicationAlters'>
                                                                                                                <p>
                                                                                                                    No message yet                                                                                        </p>
                                                                                                            </div></>
                                                                                                        }





                                                                                                    </>
                                                                                                )
                                                                                            })}

                                                                                    </>
                                                                                    : null}

                                                                            </div>

                                                                        </div>


                                                                        <div className={`  tab-pane fade show Ticketviewexpands   ${state.FormsIDList.ActiveTabs == 1
                                                                            ? "active "
                                                                            : ""
                                                                            }`}
                                                                            id="ex3-tabs-1"
                                                                            role="tabpanel"
                                                                            aria-labelledby="ex3-tab-1">




                                                                            <div className={`timeline timelineTicketListedRightside ${TickeREtrievdatas?.status == 3 ? "timelinewidthchanges ForStatusResolved" : ""}`}
                                                                                ref={timelineRef}
                                                                            >
                                                                                {state.internalTicketRemarks.InternalDepartments_TicketsretrieveRemark != undefined &&
                                                                                    state.internalTicketRemarks.InternalDepartments_TicketsretrieveRemark.length > 0 ?
                                                                                    <>
                                                                                        {state.internalTicketRemarks.InternalDepartments_TicketsretrieveRemark != undefined &&
                                                                                            state.internalTicketRemarks.InternalDepartments_TicketsretrieveRemark.length > 0 && state.internalTicketRemarks.InternalDepartments_TicketsretrieveRemark.map((item, index) => {
                                                                                                console.log(index + 1, state.internalTicketRemarks.InternalDepartments_TicketsretrieveRemark.length, "Saidjopsadosdoisad oasid");

                                                                                                const firstName = item.uds_user_id?.first_name ? item.uds_user_id?.first_name.toUpperCase() : "";
                                                                                                const formattedName = firstName ? `${firstName.charAt(0)}${firstName.charAt(firstName.length - 1)}` : "N/A";

                                                                                                return (
                                                                                                    <>

                                                                                                        {item.name == item.description ?

                                                                                                            <div className='Movedrecords' key={index}>
                                                                                                                <div className='Arrowuds'><img src={doublArrow} /></div>
                                                                                                                {index + 1 == state.internalTicketRemarks.InternalDepartments_TicketsretrieveRemark.length ? null : (
                                                                                                                    <>
                                                                                                                        <div className="Lineofnext"></div>
                                                                                                                    </>
                                                                                                                )}

                                                                                                                <div className='Movedrecordsdetails'>

                                                                                                                    <p><span className="timestampcreated">{item.created_at ? formatedDateList(item.created_at) : ""}</span></p>
                                                                                                                    <>
                                                                                                                        {
                                                                                                                            item.name === "Open to In Progress" || item.name === "In Progress to Review" ?

                                                                                                                                <>
                                                                                                                                    {item.name == "Open to In Progress" ?

                                                                                                                                        <>
                                                                                                                                            <p>{`Moved from ${`' Open ' to ' In Progress '`}`}</p>
                                                                                                                                        </> :

                                                                                                                                        <p>{`Moved from ${`' In Progress ' to ' Review '`}`}</p>
                                                                                                                                    }

                                                                                                                                </>

                                                                                                                                :
                                                                                                                                <p>{item.name} </p>

                                                                                                                        }
                                                                                                                    </>




                                                                                                                </div>


                                                                                                            </div>
                                                                                                            :

                                                                                                            <div className="timeline-item"
                                                                                                                ref={chatContainerRef}>
                                                                                                                <div className="timeline-icon TimeLinePersongIMGS">
                                                                                                                    {/* <img src={ticketactiveimgs} className='personImg' alt="" /> */}
                                                                                                                    <span>{formattedName}</span>
                                                                                                                    {/* <img src={profile2} alt="User" className='personImg' /> */}
                                                                                                                </div>

                                                                                                                {index + 1 == state.internalTicketRemarks.InternalDepartments_TicketsretrieveRemark.length ? null : (
                                                                                                                    <div className='Lineofnext'></div>
                                                                                                                )}
                                                                                                                <div className={`timeline-content ${index + 1 != state.internalTicketRemarks.InternalDepartments_TicketsretrieveRemark.length ? "forlefted" : ""}`} >
                                                                                                                    <div className='EscalationPersondetails'>


                                                                                                                        {item.name ? <p className="message">

                                                                                                                            <p className="user-name"

                                                                                                                            >

                                                                                                                                <span>
                                                                                                                                    {
                                                                                                                                        state.SideBarFiles.LoginIDs == item.uds_user_id?.id ? "You" :
                                                                                                                                            item.uds_user_id?.first_name ? capitalizeFirstLetter(item.uds_user_id?.first_name) : "Not mention"

                                                                                                                                    }
                                                                                                                                </span>

                                                                                                                                <span className="timestamp">{item.created_at ? formatedDateList(item.created_at) : ""}</span>
                                                                                                                            </p>


                                                                                                                            {item.name ? capitalizeFirstLetter(item.name) : ""}


                                                                                                                            {Array.isArray(item.documents) && item.documents.length > 0 ? (
                                                                                                                                <div className="attachment">
                                                                                                                                    <img src={galleyimg} alt="Attachment" />
                                                                                                                                    <span>{item.documents.length} File Attached</span>

                                                                                                                                    {item.documents.map((document, index) => (
                                                                                                                                        <button
                                                                                                                                            key={index}
                                                                                                                                            className="download-btn"
                                                                                                                                            onClick={() => downloadAll(item.documents)}
                                                                                                                                        >
                                                                                                                                            <img src={downloadimg} alt="Download" />
                                                                                                                                        </button>
                                                                                                                                    ))}
                                                                                                                                </div>
                                                                                                                            ) : null}

                                                                                                                        </p>
                                                                                                                            : null}



                                                                                                                    </div>
                                                                                                                    <>


                                                                                                                        {/* {item.documents !== undefined && item.documents !== null && item.documents.length > 0 ? (
                                                                                                                            <div className="attachment">
                                                                                                                                <img src={galleyimg} alt="Attachment" />
                                                                                                                                <span>{item.documents.length} File Attached</span>

                                                                                                                                {item.documents.map((document, index) => (
                                                                                                                                    <button
                                                                                                                                        key={index}
                                                                                                                                        className="download-btn"
                                                                                                                                        onClick={() => {
                                                                                                                                            downloadAll(item.documents)
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        <img src={downloadimg} alt="Download" />
                                                                                                                                    </button>
                                                                                                                                ))}


                                                                                                                            </div>
                                                                                                                        ) : null} */}



                                                                                                                    </>

                                                                                                                </div>
                                                                                                            </div>
                                                                                                        }




                                                                                                    </>
                                                                                                )
                                                                                            })}

                                                                                    </>
                                                                                    :
                                                                                    <><div className='CommunicationAlters'>
                                                                                        <p>
                                                                                            No message yet                                                                                        </p>
                                                                                    </div></>}
                                                                            </div>

                                                                        </div>




                                                                        <div
                                                                            className={`  tab-pane fade show   ${state.FormsIDList.ActiveTabs == 2
                                                                                ? "active  "
                                                                                : ""
                                                                                }`}
                                                                            id="ex3-tabs-2"
                                                                            role="tabpanel"
                                                                            aria-labelledby="ex3-tab-2"
                                                                        >
                                                                            <div className={`timeline  timelineTicketListedRightside ${TickeREtrievdatas?.status == 3 ? "timelinewidthchanges ForStatusResolved" : ""}`} style={{ marginTop: "20px" }} ref={Remarkesref}>
                                                                                {state.internalTicketFeedBack.InternalDepartments_TicketsFeedback != undefined && state.internalTicketFeedBack.InternalDepartments_TicketsFeedback.length > 0 && state.internalTicketFeedBack.InternalDepartments_TicketsFeedback.map((item) => {

                                                                                    return (
                                                                                        <>
                                                                                            <div className="timeline-item">
                                                                                                <div className="timeline-icon TimeLinePersongIMGS">
                                                                                                    <img src={ticketactiveimgs} alt="User" className='personImg' />
                                                                                                </div>
                                                                                                <div className="timeline-content TicketClientFeedback">
                                                                                                    <div className='EscalationPersondetails'>
                                                                                                        <p className="user-name">{item.client_user_id?.first_name ? capitalizeEachWord(item.client_user_id?.first_name.toLowerCase()) : ""}</p>
                                                                                                        <div className='satificedandlabels'>


                                                                                                            <span className="timestamp">
                                                                                                                {item.created_at ? formatedDateList(item.created_at) : ""}

                                                                                                            </span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <p className="messageclients">
                                                                                                        {item.feedbacks ? capitalizeEachWord(item.feedbacks) : ""}
                                                                                                    </p>

                                                                                                    <div className='Messageimgs'>

                                                                                                        {feedbackOptions.map((option) => (
                                                                                                            <div
                                                                                                                key={option.id}
                                                                                                                aria-selected={item.satisfaction === option.id}

                                                                                                                className={`feedback-option ${item.satisfaction === option.id ? "active" : ""}`}

                                                                                                            >
                                                                                                                <img
                                                                                                                    src={item.satisfaction == option.id ? option.backimg : option.imgSrc}
                                                                                                                    alt={option.label} />
                                                                                                                <span className={`${item.satisfaction === option.id ? "activelabe" : ""}`}>{option.label}
                                                                                                                </span>
                                                                                                            </div>
                                                                                                        ))}
                                                                                                    </div>

                                                                                                </div>
                                                                                            </div>
                                                                                        </>
                                                                                    )
                                                                                })}

                                                                            </div>

                                                                        </div>



                                                                    </div>


                                                                </>

                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>




        </>



    )
}

export default InternalsView